// Billing and email delivery/consent fields are written only by server handlers.
export function editableProfileFields<T extends object>(profile: T): Omit<T, 'subscription' | 'subscriptionProvider' | 'stripeCustomerId' | 'lifecycleEmail'> {
  const { subscription, subscriptionProvider, stripeCustomerId, stripeSubscription,
    subscriptionSyncedAt, billingCheckedAtMs, hasUsedTrial, lifecycleEmail, ...editable } = profile as any;
  return editable;
}
